import React from 'react'
import type { ReactNode, FC } from 'react'
import { createStyles, makeStyles } from '@material-ui/core/styles'

import { Typography as BaseTypography } from '@homeviews/shared-ui'

const useStyles = makeStyles((theme) =>
  createStyles({
    h1: {
      fontSize: '26px',
      marginBottom: '30px',
    },
    h2: {
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '23px',
      letterSpacing: '-0.26px',
    },
    subtitle1: {
      display: 'inline-block',
      margin: '8px 0 0 20px',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '17px',
      letterSpacing: '-0.26px',
      color: theme.colors.grey600,
    },
    subtitle2: {
      margin: '10px 0 0',
      fontSize: '18px',
      fontWeight: 500,
      lineHeight: '23px',
      letterSpacing: '-0.18px',
      color: theme.colors.grey600,
    },
    body1: {
      margin: '13px 0 19px',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '20px',
      letterSpacing: '-0.26px',
      color: theme.colors.grey800,
    },
    body2: {
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '22px',
      letterSpacing: '0.1px',
      color: theme.colors.grey480,
    },
  }),
)

type TypographyProps = {
  children: ReactNode
  variant: 'h1' | 'h2' | 'subtitle1' | 'subtitle2' | 'body1' | 'body2'
  className?: string
}

export const Typography: FC<TypographyProps> = ({
  children,
  variant,
  className,
}) => {
  const classes = useStyles()

  return (
    <BaseTypography
      variant={variant}
      classes={{
        [variant]: `${classes[variant]} ${className || ''}`,
      }}
    >
      {children}
    </BaseTypography>
  )
}
